import cheque from './cheque';
import toolbar from './toolbar';
import content from './content';
export default { ...cheque, ...toolbar, ...content };
